/* eslint no-param-reassign:  ["error", { "props": false }] */
/* eslint no-shadow: 0 */

import { get, isNil } from 'lodash';
import {
  getTaskCompletionQuestionTypes,
  listTaskCompletionItem,
  addTaskCompletionItem,
  updateTaskCompletionItem,
  resortTaskCompletionItem,
  removeTaskCompletionItem,
} from '@/api';

import {
  TASK_COMPLETION_TYPES,
  TASK_COMPLETION_ITEMS,
  ADD_TASK_COMPLETION_ITEM,
  REMOVE_TASK_COMPLETION_ITEM,
  EDIT_TASK_COMPLETION_ITEM,
  SET_TASK_COMPLETION_ITEM,
  RESORT_TASK_COMPLETION_ITEM,
  UNSET_EDITING_INDEX,
} from '@/store/mutation-types';


const state = {
  taskCompletionItems: [],
  taskCompletionRankRange: {},
  taskCompletionTypes: [],
  editingIndex: null,
};

const getters = {
  editingIndex(state) {
    return state.editingIndex;
  },
  list(state) {
    return state.taskCompletionItems;
  },
  types(state) {
    // gives all the different types of task completion items
    return state.taskCompletionTypes;
  },
  taskRankRange(state) {
    return state.taskCompletionRankRange;
  },
  isExistingQuestion(state) {
    // identifies if the question being edited is an existing or a new question
    if (isNil(state.editingIndex)) {
      return false;
    }
    return state.taskCompletionItems[state.editingIndex].task_completion_item_id > 0;
  },
};

const actions = {
  getTaskCompletionQuestionList({ commit }, taskId) {
    const userToken = this.getters['auth/userToken'];
    listTaskCompletionItem(userToken, taskId)
      .then(({ data }) => {
        if (data[1].data === false) {
          const taskCompletionItems = [];
          const taskCompletionRankRange = {};
          commit(TASK_COMPLETION_ITEMS, { taskCompletionItems, taskCompletionRankRange });
        } else {
          const taskCompletionItems = get(data, '[1].data.details.task_completion_list', []);
          const taskCompletionRankRange = get(data, '[1].data.details.task_completion_rank_range');
          commit(TASK_COMPLETION_ITEMS, { taskCompletionItems, taskCompletionRankRange });
        }
      });
  },
  getTaskCompletionQuestionTypes({ commit }) {
    const userToken = this.getters['auth/userToken'];
    getTaskCompletionQuestionTypes(userToken)
      .then(({ data }) => {
        // extract the types from the data and set to the state
        // const status = get(data, '[1].status');
        const taskCompletionTypes = get(data, '[1].data.details');
        commit(TASK_COMPLETION_TYPES, taskCompletionTypes);
      });
  },
  addQuestion({ commit }, { taskId }) {
    // add  a new question to the list, local only
    const taskCompletionitems = this.getters['taskCompletion/list'];
    const taskCompletionItem = {
      task_completion_rank: taskCompletionitems.length + 1,
      task_completion_text: null,
      task_completion_type_id: null,
      task_completion_elements: null,
      task_id: taskId,
    };
    commit(ADD_TASK_COMPLETION_ITEM, taskCompletionItem);
  },
  insertQuestion({ commit }) {
    // insert new question into the remote server
    const userToken = this.getters['auth/userToken'];
    const taskCompletionItems = this.getters['taskCompletion/list'];
    const index = taskCompletionItems.length - 1;
    addTaskCompletionItem(userToken, taskCompletionItems[index])
      .then(({ data }) => {
        const isExistingQuestion = get(data, '[1].data.details.task_completion_item_id');
        taskCompletionItems[index].task_completion_item_id = isExistingQuestion;
        const status = get(data, '[1].status');
        if (status === 'SUCCESS') {
          this.dispatch('auth/setFlashMessage', { message: 'Effort saved successfully', type: 'success' });
        } else {
          this.dispatch('auth/setFlashMessage', { message: 'Failed to save effort', type: 'error' });
        }
        commit(SET_TASK_COMPLETION_ITEM, taskCompletionItems);
        commit(UNSET_EDITING_INDEX);
      })
      .catch(() => {
        this.dispatch('auth/setFlashMessage', { message: 'Failed to save effort', type: 'error' });
      });
  },
  setQuestion({ commit }, questionFields) {
    //  on user action, set the fields
    const taskCompletionItems = this.getters['taskCompletion/list'];
    taskCompletionItems[questionFields.index][questionFields.field] = questionFields.value;
    commit(SET_TASK_COMPLETION_ITEM, taskCompletionItems);
  },
  updateQuestion({ commit }) {
    // update the remote copy of the question
    const index = this.getters['taskCompletion/editingIndex'];
    const userToken = this.getters['auth/userToken'];
    const taskCompletionItems = this.getters['taskCompletion/list'];
    updateTaskCompletionItem(userToken, taskCompletionItems[index])
      .then(({ data }) => {
        commit(UNSET_EDITING_INDEX);
        const status = get(data, '[1].status');
        if (status === 'SUCCESS') {
          this.dispatch('auth/setFlashMessage', { message: 'Effort saved successfully', type: 'success' });
        } else {
          this.dispatch('auth/setFlashMessage', { message: 'Failed to save effort', type: 'error' });
        }
      })
      .catch(() => {
        this.dispatch('auth/setFlashMessage', { message: 'Failed to save effort', type: 'error' });
      });
  },
  removeQuestion({ commit }, index) {
    const userToken = this.getters['auth/userToken'];
    const taskCompletionItems = this.getters['taskCompletion/list'];
    commit(REMOVE_TASK_COMPLETION_ITEM, index);
    removeTaskCompletionItem(userToken, taskCompletionItems[index])
      .then(({ data }) => {
        const status = get(data, '[1].status');
        if (status === 'SUCCESS') {
          this.dispatch('auth/setFlashMessage', { message: 'Effort saved successfully', type: 'success' });
        } else {
          this.dispatch('auth/setFlashMessage', { message: 'Failed to save effort', type: 'error' });
        }
      })
      .catch(() => {
        this.dispatch('auth/setFlashMessage', { message: 'Failed to save effort', type: 'error' });
      });
  },
  editQuestion({ commit }, index) {
    commit(EDIT_TASK_COMPLETION_ITEM, index);
  },
  resortQuestion({ commit }, { taskCompletionItems, taskId }) {
    const taskCompletionList = [];
    const userToken = this.getters['auth/userToken'];
    const taskRankRange = {
      min_user_task_completion_rank: 1,
      max_user_task_completion_rank: taskCompletionItems.length,
    };
    for (let i = 0; i < taskCompletionItems.length; i += 1) {
      const rank = i + 1;
      const taskCompletionItemId = taskCompletionItems[i].task_completion_item_id;
      taskCompletionList[i] = { [rank]: taskCompletionItemId };
    }
    commit(RESORT_TASK_COMPLETION_ITEM, taskCompletionItems);
    resortTaskCompletionItem(userToken, taskId, taskRankRange, taskCompletionList)
      .then(({ data }) => {
        const status = get(data, '[1].status');
        if (status === 'SUCCESS') {
          this.dispatch('auth/setFlashMessage', { message: 'Effort saved successfully', type: 'success' });
        } else {
          this.dispatch('auth/setFlashMessage', { message: 'Failed to save effort', type: 'error' });
        }
      })
      .catch(() => {
        this.dispatch('auth/setFlashMessage', { message: 'Failed to save effort', type: 'error' });
      });
  },
};

const mutations = {
  [TASK_COMPLETION_ITEMS](state, { taskCompletionItems, taskCompletionRankRange }) {
    taskCompletionItems.sort((a, b) => a.task_completion_rank - b.task_completion_rank);
    state.taskCompletionItems = taskCompletionItems;
    state.taskCompletionRankRange = taskCompletionRankRange;
  },

  [TASK_COMPLETION_TYPES](state, taskCompletionTypes) {
    state.taskCompletionTypes = taskCompletionTypes;
  },

  [ADD_TASK_COMPLETION_ITEM](state, task) {
    state.editingIndex = state.taskCompletionItems.length;
    state.taskCompletionItems = [
      ...state.taskCompletionItems,
      task,
    ];
  },

  [UNSET_EDITING_INDEX](state) {
    state.editingIndex = null;
  },

  [REMOVE_TASK_COMPLETION_ITEM](state, index) {
    state.taskCompletionItems = [
      ...state.taskCompletionItems.slice(0, index),
      ...state.taskCompletionItems.slice(index + 1, state.taskCompletionItems.length),
    ];
  },

  [EDIT_TASK_COMPLETION_ITEM](state, index) {
    state.editingIndex = index;
  },

  [SET_TASK_COMPLETION_ITEM](state, taskCompletionItems) {
    state.taskCompletionItems = taskCompletionItems;
  },

  [RESORT_TASK_COMPLETION_ITEM](state, taskCompletionItems) {
    state.taskCompletionItems = taskCompletionItems;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/task_completion.js